export const DEFAULT_PRODUCT_PRICE = 0
